<template>
  <div class="inners">
    <!--{{ spaceSize }}-->
    <!--    {{isVipUser}}-->
    <!--        {{switchData}}-->
    <div class="left" ref="parentRef" :key="refreshCount">
      <div class="flex" @click="toEditUserInfo">
        <img
            width="20"
            height="20"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAU9JREFUOE+l1LsublEUxfEfDUoNEU8gOucREJcQicsLKE+JgkShJCFKEqXecU0kbi8g4gUkGrWecGTK2sm2823f3sx6rf8aY465Zov6NY597GC1eL2lJi9gB2hL9zawnGfUAY4l2BvmsYY+fIFWBWawdhxiGl24SdB1rITSKsBR/EMoe0Q/dvEX3bhO0CVsNQPmYZO4xwX+pFAWcYRhbGPhO2ARFvaiOnGJATyhN0Hn8FoGzGDvmEi9yofZgwd05GFlPRxJjS+DRTDR03g07H4qy14rKmwGi/mLlAN2nGAvZXM4iFOEsggg0stXU1jR8jlC4RCufgIrAiO5UNmK/zlgKIuexXCfYBZfbJZZbgSsBStTGEOaKYzBraSsUcpniG1SrAhq5jubZZbjj06lHmZnnrFXFVZ1OdRamdlgb6a/Wetyg8N3GfA2bZDfAm8/AIZIVWxiy9xbAAAAAElFTkSuQmCC"
        />
      </div>
      <div class="bottoms">
        <div class="avactor">
          <div>
            <el-avatar
                v-if="userInfo.avatar"
                :size="100"
                :src="userInfo.avatar"
            />
            <el-avatar v-else :size="100">
              <img style="height: 40px; width: 40px" :src="require('@/assets/default/avatar.png')"/>
            </el-avatar>
          </div>
          <div style="display: flex;justify-content: center;align-items: center">
            <span style="margin-right: 5px">{{ userInfo.userName }}</span>
            <span v-if="userInfo.sex===1" style="padding-top: 4px">
              <img style="width: 16px;height: 16px" :src="require('@/assets/usercenter/man_pc.png')"/>
            </span>
            <span v-else style="padding-top: 4px">
              <img style="width: 16px;height: 16px" :src="require('@/assets/usercenter/woman_pc.png')"/>
            </span>
          </div>
          <div>{{ userInfo.guid }}</div>
          <div
              style="width: 80%; margin: 20px auto; border: 1px solid #e8e8e8;"
          ></div>
        </div>
        <div class="set_tool">
          <div>
            <span>
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAutJREFUWEfdmD9IW0Ecx78XpSQPCg4qhrqIm3GoEmiXDBLcmimCShZxyJSKIYggCeqSTQ24dRGHGEISROimieCSFkQEiYODiwQlRpA2voSguXIPMxQ173fPpg39QfKG+97v+3l39+4fw2Nwzt+Uy2UvAE+tVrMxxt7Wy5rx5Jz/NJlMOQBRi8XyhTFWFT5M/Kmq+o5z/hXA+2aYE3IeM8Y+KYqSZ6JlVFX9/g9h6rzHiqJ8YKqq+jjn64S3aLqEMfZZAGU55x+b7kYwYIx9Y6VS6UezBzCBRZOIgc7u7u44tcLf0P0/QJVKBalUCnt7e7i4uIDZbMbg4CDGx8cxNDRkuDENtdDNzQ0CgQDOz8+fNZ6amsL09LQhKGkgzjl8Ph9OTk4aGoZCIYyOjkpDSQNls1nMz8/rGvX09CAej4MxbTEghzTQ2toatre3SQabm5vo6+sjaesiaaBgMIiDgwOSyerqKux2O0lrGGhlZQU7Ozskk42NDfT395O0hoFE64hW0ovOzk4kk0mYTCY96W/l0l1Wq9Xg9XpxdnbW0Ghubg4ul0sKRoilgUSlq6sr+P1+5PP5Zw3HxsYwMzMjDWMYSFQslUqIRqPY3d1FoVBAW1sbbDabNlM7HA5DMIaBHh4ecHp6isvLS5TLZVSrVbS3t2vjxWKxwGq1YmBgQIOUDakuEyCJRAJbW1u4vb1t6NXR0QGPxwPRfTJgZCCxmC4sLODw8FDqpcU8FA6HtcWXEmSgpaUlZDIZSs4nGqfTicXFRVJdEtDR0RFmZ2dJCV8SRSIRDA8P6+YgAS0vLyOdTusmaySgthIJyO124/r6+lVAXV1d2oZOL0hAIyMjEF/Ya0J8afv7+7opSECTk5Mvzsq6Do+C3t5ebbrQCxKQWCJisRhyuRyKxaI4euP+/l4cW57kFxsyMUGKn6Io6O7u1vbaExMT2oSpFyQgvSR/srz1Dootd5RuucuGlruOEQOypS6s6l9Iq1zp/QLezIWUqabIMQAAAABJRU5ErkJggg=="/>
            </span>
            <span>{{ userInfo.account }}</span>
          </div>
          <div>
            <span>
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAeNJREFUWEftmL1qAkEQx//TRO4glYKCLyCkSWXyEGnEStKIRQpJ/ADBZxAEPwIWKcQmWIlN3iGJVZqAPoCgoE2Ce5pmwi4RRC7eRjxzxW1xB7f/nfntMLs3u4SfxswnlmXdALgGcMbMp+s+N95E9AngHcCjYRgPRPQl/ZB8CCGizPwE4NwN5xo234joyjTNMcnICCFe/xFmzftmmuYFCSFumfleYxauS4joTgI9M/Ol6940HBDRiwT6cDuBNViURCY6LRYL1h1wDJ020Gq1wnA4hGVZf+IyDAOxWAyBQEBrnBbQbDZDNpvFZDLRMrotikQiaLVaCIVCjuO1gDqdDtrttq2xQqGAeDyu+gaDAer1uq0uk8kgnU4fBqjRaKDX6zka2yVIJpPI5/OONrQitAlUq9UQDocdDUvBdDpFsVhUWteAut0uotGoFtB4PEYqlfKBfo2WHyGnRPIj5EdoHYHNjdHfh+zyYjNC5XIZwWDQKX1U/3w+R6VScXen1iKxEbn2L9v2RURIJBLqc7/fB7N9AXo0IFkLVatVBVQqlVRNZNcOCrSrQJP51Gw2FUMul1N5Y9cOWqB5roSVM14ulxiNRt4o8vddWfuM895B0YtHaW9dNnjuOkYmnqcurNYrwStXet8BwLigBWlEtQAAAABJRU5ErkJggg=="/>
            </span>
            <span v-if="userInfo.phone!==''&& userInfo.phone!==null">
                          {{ userInfo.phone }}
                        </span>
            <span v-if="userInfo.phone!=='' && userInfo.phone!==null">
              <el-button link type="primary" @click="toCancelBindPhone"
              >{{ $t("common.goto.update") }}</el-button>
            </span>
            <span v-else><el-button type="primary"
                                    link
                                    @click="bindPhone">{{ $t("common.goto.bind") }}</el-button>
            </span>
          </div>
          <div>
            <span><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAe9JREFUWEftmL9rIkEUx78PJbgLFiJioY21zWETK+20SWNtK6liZ60o+BfYHbbWNtdo5w9I0kgaO8HKQkSEhJ2FoLxjJAsJl2SGcze3R9xit3jffd/PvHn7Y4bwcjDzhW3b1wDKANLMHHZiXlyJ6AnAHEDPMIyfRPQsfUiehBAJZv4F4IcX5ho5H4joyjTNFcnKCCHu/yGMw/tgmuYlCSFumLmjMQrPJURUlUC3zJz13E3DgIjuJNCj1w2swXKUyEYny7JY94av0J2BVFX+/yo0HA6xWq1UA9OKJxIJFAqFT7XKCuXzeTC70/dEhNFodBpQLpc7JgiHw8hm/+51tVgssFwuj3nG47E7QDJLuVxGpVJBIBDQmiIpmk6naLfbsCzLfSCZMZPJoNFoIBKJfAp1OBzQ7XbR6/Xe6FytkJM5Fouh1WohnU6/C7Xb7dBsNjGbzf6IewIkXYLBIKrVKkql0hvT+XyOer2OzWbzLqxnQI6bfIxrtRpCoRD6/T46nQ72+/2H0+k5kHROpVJIJpOYTCbKZv8SICXFK8EZSFWtc4W+X4WKxSJs21YNXCtuGAYGg8FpH9f1eo3tdqtlqBJFo1HE4/HTgFQmbseVP2huG6ry+Q/IdwtFPy6l/bXZ4LvtGNn1vtqwch5Dv2zp/QbXkD2golKThQAAAABJRU5ErkJggg=="
                alt=""/></span>
            <span v-if="userInfo.email!==''&& userInfo.email!==null">{{ userInfo.email }}</span>
            <span v-if="userInfo.email!==''&& userInfo.email!==null">
              <el-button link type="primary" @click="toCancelBindEmail">{{ $t("common.goto.update") }}</el-button>
            </span>
            <span v-else>
            <el-button link type="primary" @click="toSetEmail"
            >{{ $t("common.goto.bind") }}
            </el-button
            >
            </span>
          </div>
          <div><span><img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAdtJREFUWEftWDFrwkAYfZ9DwUAREVwq6Ch26dYiuIku/QPavYstOrsLjoII0kmEOjn2F7i03XQogrNO4tLiRQrylQuNWLDJtRqbYjIkJN/Lfe/evbvkPsLnwcxHuq5fA7gCcMrMx2bMiSsRvQF4AXDv9/vviOhd5iF5EkKcMPMDgDMnkiu02SeiS03TJiSVEUI8/yEZk29f07RzEkLcMHNdoReOQ4joVhJ6ZOYLx7MpJCCiJ0no1WkDK3AxINLoNJ/PWfWFfeA8QnYqKylUr9fR7XbBbD26yWQS1WrVLqdlXIlQPp/HeDxWStTr9ZRw34E8Qnby/U+FcrkcJpOJ0blarYZwOLzq6GKxQKFQgK7rxjPpoVarhdFotML4fD5ks1mkUik7gaCk0DqheDyOQCDwhdBgMFjdS0LreDMQi8XQbrd3Q+ins2wTPhKJoNPpHAAhFQ9JhdLpNDKZDEyPhUKh3Sn0Gw8tl0tEo1GDkPTY4QyZnSvlLNurqT0PbRoSbx2yMupwOES5XMZsNrPzsxEvlUpoNpvGdF8/5DpUqVSQSCS2+0ErFouYTqdKZOxAwWAQjUZjO0J2SXYdV/ra7zqpVXvu2yi6cSvtrmKD68ox0mCuKliZjndLSe8DfgnNoOjBOnAAAAAASUVORK5CYII="/></span>{{
              userInfo.country
            }}
          </div>
          <div v-if="!isEnterpriseMainUser">
            <span><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAl1JREFUWEftmD2IGkEcxd+Ixg+MhQiCsbnSS5NCTRotxEqDnTa5K02VYKeglSJWB3IEmwg2cmJno2IhgoIkueYOJAjaaiFoY3AFlZswS5TYZPe43dwm3BQqzn/n/fbNm/0Ygl+NUvpsvV6/B/AOwEtK6fN9nxzfhJAfAL4DuNLr9Z8JIRumQ9gHx3EvKKV1AK/kEBcx5i0h5K3BYJgS5gzHcd8eEWbPe2swGF4TjuM+UEo/iTgL2UsIIR8Z0BdK6RvZ1UQIEEK+MqCl3AEWwcKXsKCT1WpFxR7wN+qegIRc/vccajabmM1mQicmqt9qtSIQCPyxVtAhr9crSkxMESEE3W5XOUCMpNfryQOkUqlwd3cnxpijGsmB7HY7MpkMTk5O0O/3kU6nsd1uRYNJDpTNZnF6eopGo4Hz83NcXl6iVqvxQNFoFDqd7ghuMpkc+mWZskKhAK1Wi3w+z8NUKhWUSiUegv02Go1HQIPBAKlU6vCfpA6xVXJxcQGXy3UQKBaLKJfLjzNlwWAQiUQC1WoV4/EYfr8fbrcbZ2dnmE6nMJvNYGH/vW02GyyXS3kcisfjcDqdiEQivIDNZuPhWMjb7Tbq9TpMJtMR0M3NDWKxmDxAyWQSHo+HX12ssQCzC2cul0Or1eId02g0R0CLxQLX19fyAIVCIYTDYfbcchDY7XY80Gg0EpUjSUMtSlGg6P8D8vl8YNMiRVOr1eh0Og+7lw2HQ8zncyl4YLFY4HA4HgYkCck9BhF8HrrHWJKUPgEJ2ai8F0Ulvkora7NBcdsxLGSK2rDap14pW3o/AcbBaqDlgsyyAAAAAElFTkSuQmCC"/></span>
            <span v-if="userInfo.realName===''|| userInfo.realName===null">
              <el-button type="info" text style="color: black !important;padding: 0px !important;">{{
                  $t("common.unauthorized")
                }}，</el-button>
              <el-button
                  style="margin-left: -8px"
                  link
                  type="primary"
                  @click="toCheckUser"
              >{{ $t("common.certified.to") }}
            </el-button></span>
            <span v-else>
              <span>{{ userInfo.realName }}</span>
              <el-button
                  link
                  type="primary"
                  @click="toCheckUserChange"
              >{{ $t("common.goto.update") }}
            </el-button>
              </span>
          </div>
          <div v-if="isEnterpriseMainUser"><span>
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAs9JREFUWEfdmEFIYlEUhv9LIGUOLVrFiC4CF81mduMia9FW3ZgKWiRF6kJ34aZNECFBkDBEOrRoM20SAxl0EUW7cVYFMWslGARXpfSMWtzhPMaBmKfvvje96TFnoYt3zvk/zz33PO9l+GWcc0u3240DiAJ4xzl/03tmxDdjrAPgO4DPIyMjnxhjj6TD6EOSpLec8y8A3hshLpDzijHmtVqtPxhVRpKkb68I0+O9slqtH5gkSSnO+UeBX2G4C2MsTUBfOeduw9UEBBhjNQJqG93AAiyyCzU6u7+/56IB/8Lv/wK6vLzE8fExrq+vaXRgYmICMzMzCIfDGBsb01VQ3RXK5/M4OjpSFB0fH8f29jZcLpdmKF1AJycn2N3dHShGUIeHh5orpRno4eEBgUAAnQ5N/sEWjUaRSCTU3J491wxUq9WQyWSEROx2e99l7ZdAM1CpVEIulxMCGhoawvn5Oc0XIX95FmmdQ9VqFdlsVkjAZrOhUqkI+facNAM1m015W4uYx+PB1taWiOtvH81AFLm5uYnT09OBQrRM+/v7mJqaMh6o3W4jnU6jXq/3FUsmk4hEIppgdPVQT4GadWNjQ1HQ4XCgUChgdHTUWKBWqwVq6rOzMzQajYFiFosFbrcbc3Nz8uuEdpyICfcQzZ/19XU8PT2J5H3mQ31Eo2J4eFg1VhhoYWEBNzc3iglpAFI1isViX8G1tTX4/f6XA5qdnQXnyn+dVlZWsLS0BJ/Ph7u7O0XRUCiEVCr1ckDUB/1sdXUVi4uLcgVub28V3YLBoLwz1Ux4yQYBeb1exONxzM/P4/FRPl79YS8ORKI0f/Ta8vIyYrGYarhwhXZ2dlAul1UTKjnQlj84OMDk5KRqvDBQt9vF3t4eLi4uhCtFrw+n0ykv5/T0tCrMX01qoew6nIQrpCO3rhDzHRTNeJQ212WD6a5jqPNMdWHV2wpmudL7CUnNaqAClQ7nAAAAAElFTkSuQmCC"/>
          </span>
            <span>{{ userInfo.account }}</span>
          </div>
        </div>
        <div
            style="width: 80%; margin: 20px auto; border: 1px solid #e8e8e8;"
        ></div>
        <div class="userInfo_message" v-loading="leftLoading">
          <div class="message_info_item" v-for="item in messageInfo" :key="item.id">
            <div>
              <span class="font">{{ item.name }}</span>
            </div>
            <div>
<!--              <span>{{ ` (` }}</span>-->
              <span class="font" :style="{color:item.id===4?'#D93737':'#0073FF'}">
              <template v-if="item.id!==2">
                   {{
                  `${item.sum}`
                }}
                </template>
                <template v-else>
                   {{
                    `${spaceSizeFormat(item.sum, false)}`
                  }}
                </template>
              </span>/<span class="font">
                <template v-if="item.id!==2">
                   {{
                    `${item.allCount} ${item.units}`
                  }}
                </template>
                <template v-else>
                  {{
                    `${spaceSizeFormat(item.allCount)}`
                  }}
                </template>
              </span>
            </div>
            <div style="margin-top: 5px">
              <el-progress class="prog_progress" :show-text="false" :stroke-width="9"
                           :color="item.id===4?'#D93737':'#0073FF'"
                           :percentage="(item.sum / item.allCount * 100).toFixed(0)"/>
            </div>
            <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 5px;">
              <el-button v-if="isEnterpriseMainUser||isNormalUser" link type="info" class="font"
                         style="font-size: 14px !important;color: #999999;"
                         @click="handleClickDetail(item)">
                {{ $t('common.view.detail') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right" v-if="isNormalUser">
      <div class="titles" style="margin-bottom: 20px">{{ $t("common.account.info") }}</div>
      <!-- vip 信息 -->
      <CheckVip :memberType="memberType"></CheckVip>
      <div class="line-text">{{ $t('common.exclusive') }}</div>
      <div style="display: flex;justify-content: space-between">
        <VipTab :memberType="memberType"></VipTab>
      </div>
      <div class="line-text">{{ $t('userinfo.vip.server.project') }}</div>
      <div style="display: flex;justify-content: space-between">
        <VipProduct></VipProduct>
      </div>
    </div>
    <div class="right" v-else>
      <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane :label="$t('common.space')" name="first" lazy>
          <Echarts></Echarts>
        </el-tab-pane>
        <el-tab-pane :label="$t('account.tab.bar.edm')" name="second" lazy>
          <index-edm :left-width="450"></index-edm>
        </el-tab-pane>
        <el-tab-pane :label="$t('userinfo.vip.AI')" name="third" lazy>
          <index-a-i :left-width="450"></index-a-i>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  <unBindPhone v-if="visitable" v-model="visitable" @close="close" @refresh="refresh"></unBindPhone>
  <unBindEmail v-if="visitableEmail" v-model="visitableEmail" @close="closeEmail" @refresh="refreshEmail"></unBindEmail>
</template>

<script setup>
import {onMounted, computed, ref, nextTick} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Echarts from "@/views/UserCenter/StoreDetails/Echarts.vue";
import unBindPhone from "@/components/DiaPops/unBindPhone/index.vue"
import unBindEmail from "@/components/DiaPops/unBindEmail/index.vue"
import CheckVip from "@/views/UserCenter/component/CheckVip.vue";
import VipTab from "@/views/UserCenter/component/VipTab.vue";
import VipProduct from "@/views/UserCenter/component/VipProduct.vue";
import {spaceSizeFormat} from "@/utils/file";
import IndexEdm from "@/views/UserCenter/EdmDetails/component/indexEdm.vue";
import IndexAI from "@/views/UserCenter/AIDetails/component/indexAI.vue";
import {i18n} from "@/lang";

const router = useRouter();
const store = useStore()
const activeName = ref('first')
const userInfo = computed(() => store.state.user.userInfo)
const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
// 正常普通用户
const isNormalUser = computed(() => store.getters["user/isNormalUser"])

const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
const spaceSize = computed(() => store.state.cloud.spaceSize)

const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const companyInformation = computed(() => store.state.user.companyInformation)

const isVipUser = computed(() => store.getters['user/isVipUser'])
// 会员选择 主要 ！！！
const memberType = computed(() => {
      // isVip 1,2,3
      // product 6,7,8
      if (isVipUser.value) {
        return userInfo.value.isVip * 1 + 5
      } else {
        return 5
      }
    }
)
// 判断是企业 还是 个人
// const switchData = computed(() => {
//   console.log(userDataInformation.value, companyInformation.value,'dddd')
//   return isNormalUser.value ? userDataInformation.value : companyInformation.value
// })

const messageInfo = computed(() => {
  const targetData = [
    {
      id: 1,
      name: i18n.global.t('common.seat'),
      sum: mailWorkPosition.value?.freePosition,
      allCount: mailWorkPosition.value?.totalPosition,
      units: i18n.global.t('common.ph22')
    },
    {
      id: 2,
      name: i18n.global.t('common.space'),
      sum: spaceSize.value?.freeLocation || 0,
      allCount: spaceSize.value?.effectiveLocation || 0,
      units: ""
    },
    {
      id: 3,
      name: i18n.global.t('userinfo.vip.edm'),
      sum: userDataInformation.value?.freeEdmNum ? userDataInformation.value?.freeEdmNum : 0,
      allCount: userDataInformation.value?.edmTotalNum ? userDataInformation.value?.edmTotalNum : 0,
      units: i18n.global.t('common.ph23')
    },
    {
      id: 4,
      name: i18n.global.t('userinfo.vip.AI'),
      sum: userDataInformation.value?.freeAiNum ? userDataInformation.value?.freeAiNum : 0,
      allCount: userDataInformation.value?.totalAiNum ? userDataInformation.value?.totalAiNum : 0,
      units: i18n.global.t('common_ph24')
    }
  ]
  if (isEnterpriseMainUser.value || isNormalUser.value) {
    return targetData
  } else {
    const newTargetData = targetData.slice(1);
    return newTargetData
  }
})

// 详情跳转
const handleClickDetail = (item) => {
  // console.log(item, 'item')
  const {id} = item
  if (id === 1) {
    router.push('/personal/station')
  } else if (id === 2) {
    router.push('/personal/storeDetails')
  } else if (id === 3) {
    router.push('/personal/edmDetails')
  } else if (id === 4) {
    router.push('/personal/aiDetails')
  }
}

const toEditUserInfo = () => {
      router.push({path: "/personal/editInfo", query: {isQ: 0}});
    }
;

// 绑定邮箱
const toSetEmail = () => {
  router.push({path: "/personal/setemail", query: {isChange: 2}});
};

// 修改绑定的邮箱
const visitableEmail = ref(false)
const closeEmail = () => {
  visitableEmail.value = false
}
const toCancelBindEmail = () => {
  visitableEmail.value = true
  // router.push({path: "/personal/setemail", query: {isChange: 1}});
}
const refreshEmail = () => {

}

const visitable = ref(false)
const close = () => {
  visitable.value = false;
}
// 父组件刷新的次数
const refreshCount = ref(0);
const refresh = () => {
  nextTick(() => {
    refreshCount.value = Math.random();
  })
}
// 取消绑定手机号
const toCancelBindPhone = () => {
  // ElMessage.warning("您需要先解绑手机号")
  // setTimeout(() => {
  //   router.push({path: '/personal/security'})
  // }, 1500)
  // router.push({path: "/personal/setphone", query: {isChange: 1}});
  visitable.value = true
}

const bindPhone = () => {
  router.push({path: "/personal/setphone", query: {isChange: 2}});
}
const toCheckUser = () => {
  router.push({path: "/personal/realName", query: {isChange: 2}});
};
const toCheckUserChange = () => {
  router.push({path: "/personal/realName", query: {isChange: 1}});
}

// ---------------------
// 详情
const clickTargetTo = () => {
  router.push('/personal/station')
}
const clickTargetToSave = () => {
  router.push('/personal/storeDetails')
}
const clickTargetToFlow = () => {
  router.push('/personal/flowDetails')
}

const leftLoading = ref(false)

onMounted(async () => {
  try {
    leftLoading.value = true
    // await store.dispatch("cloud/queryByUserIdApis")
    leftLoading.value = false
  } catch (e) {
    leftLoading.value = false
  }
})
// -------------
</script>

<style lang="less" scoped>
@import "./less/Basic.less";

.right {
  min-height: 820px !important;
}

:deep(.el-avatar) {
  background: #f3f3f3 !important;
}

:deep(.el-tabs__item) {
  margin-right: 30px;
  padding-top: 29px;
  padding-bottom: 29px;
  cursor: pointer;
  font-size: 18px;
}

:deep(.el-button) {
  font-size: 14px !important;
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}

:deep(.el-progress-bar__inner) {
  border-radius: 0px !important;
}

:deep(.el-progress-bar__outer) {
  border-radius: 0px !important;
}

.font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.line-text {
  width: 350px;
  display: flex;
  align-items: center;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #8B4127;
  margin: 20px auto;
}

.line-text::before,
.line-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #FCDEB9;
}

.line-text::before {
  margin-right: 8px;
}

.line-text::after {
  margin-left: 8px;
}

.left_box {
  div {
    margin-bottom: 10px !important;
  }
}
</style>
